module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_library.js
 ** module id = 216
 ** module chunks = 19
 **/